(ns teamoesterreich.user-mode.profile.profile-qualifications
  (:require
    [clojure.string]
    [goog.date.DateTime]
    [reagent-material-ui.components :as mui]
    [reagent-material-ui.icons.add :refer [add]]            ;;(h/event-value e)
    [reagent-material-ui.icons.delete-icon :refer [delete]]
    [reagent-material-ui.icons.keyboard-arrow-left :refer [keyboard-arrow-left]]
    [reagent-material-ui.icons.save :refer [save]]
    [reagent.core :as r]
    [teamoesterreich.config :as config]

    [teamoesterreich.store :as store]
    [teamoesterreich.user-mode.actions :as a]

    [teamoesterreich.user-mode.modal.job-selection-modal :as job-selection-modal]
    [teamoesterreich.user-mode.navigation.bottom-bar :as bottom-bar]
    [teamoesterreich.user-mode.profile.lists :as lists]


    [teamoesterreich.user-mode.ui-helper.are-you-sure-modal :as ays-modal]
    [teamoesterreich.util.helper :as h]
    [teamoesterreich.util.log :as log]
    ))


(def DEGREES lists/DEGREES)
(def EXPERT lists/EXPERT)
(def MAX_DISTANCE lists/MAX-DISTANCE)
(def MAX_DURATION lists/MAX-DURATION)


(defn save-user [user-obj]
  (a/set-user-details user-obj))

(defn changes?-val-or-map [a b]
  (if (map? a) (not= a (merge a b))
               (and (not (nil? b)) (not= a b))))

(defn get-languages [!actual-user !qualification-form]
  (let [lang-state (merge (:languages @!actual-user) (:languages @!qualification-form))]
    (mapcat identity
            (for [[lang level] lang-state]
              (let [changed? (not= (get lang-state lang) (get-in @!actual-user [:languages lang]))]
                (when (not= level "del")
                  ^{:key (str lang "_c")}
                  [
                   [mui/grid
                    {:container false
                     :key       (str lang "_name_c")
                     :sm        4                           ;medium: 960px
                     :xs        10                          ;extra-small: 0px
                     :style     {:padding "15px" :backgroundColor (if changed? "#ffd6d2" "#ffffff")}
                     }
                    [mui/select
                     {
                      :key       (str lang "_name")
                      :fullWidth true
                      :value     lang
                      :onChange  (fn [e]
                                   (let [v (keyword (h/event-value e))]
                                     (swap! !qualification-form
                                            assoc-in
                                            [:languages v] level)
                                     (swap! !qualification-form
                                            assoc-in
                                            [:languages lang] "del"))
                                   (log/log "changed lang" @!qualification-form))
                      :label     "Sprache"}
                     (for [[l-key l-name] (lists/get-languages)]
                       ^{:key (str "lang-option" l-key)} [mui/menu-item {:value (str l-key)} l-name])
                     ]]

                   [mui/grid
                    {:container false
                     :key       (str lang "_level_c")
                     :sm        4                           ;medium: 960px
                     :xs        10                          ;extra-small: 0px
                     :style     {:padding "15px" :backgroundColor (if changed? "#ffd6d2" "#ffffff")}
                     }
                    [mui/select
                     {
                      :key       (str lang "_level")
                      :fullWidth true
                      :value     level
                      :onChange  (fn [e] (log/log "changed lang" lang (h/event-value e)) (swap! !qualification-form assoc-in [:languages lang] (h/event-value e)))
                      :label     "Level"}
                     (for [[l-key l-name] (lists/get-language_levels)]
                       ^{:key (str "lang-level-option" l-key)} [mui/menu-item {:key l-key :value l-key} l-name])
                     ]]
                   [mui/grid
                    {:container false
                     :key       (str lang "_del_c")
                     :sm        2                           ;medium: 960px
                     :xs        2                           ;extra-small: 0px
                     :style     {:padding "15px"}
                     }
                    [mui/icon-button
                     {
                      :key     (str lang "_del")
                      :onClick #(swap! !qualification-form assoc-in [:languages lang] "del")
                      :label   "Löschen"}
                     [delete]
                     ]]
                   ]

                  ))))))
(defn get-job-details [!actual-user !qualification-form]
  (let [job-names (reduce (fn [c {:keys [id label]}] (assoc c id label)) {} (:jobs (lists/get-job_details)))
        job-details (reduce (fn [c [i e]] (assoc c i e)) {} (map-indexed list (or (:job-details @!qualification-form) (:job-details @!actual-user))))
        ]
    (mapcat identity
            (for [[index job-id] job-details]
              (do (log/out "job-detail " index job-id)
                  (when job-id
                    ^{:key (str index "_c")}
                    [
                     [mui/grid
                      {:container false
                       :sm        4                         ;medium: 960px
                       :xs        8                         ;extra-small: 0px
                       :style     {}
                       }
                      [mui/typography
                       {:style {:padding         "5px" :paddingLeft "15px" :height "48px" :lineHeight "40px"
                                :backgroundColor (if (or (nil? (:job-details @!qualification-form)) (= (:job-details @!qualification-form) (:job-details @!actual-user))) "#ffffff" "#ffd6d2")
                                }}
                       ;index " -- "
                       (or (get-in job-names [job-id]) job-id)]]

                     [mui/grid
                      {:container false
                       :sm        2                         ;medium: 960px
                       :xs        4                         ;extra-small: 0px
                       :style     {}
                       }
                      [mui/icon-button
                       {:onClick (fn []
                                   (let [_job-details (mapv second (dissoc job-details index))]
                                     ;(log/out "save job modal called job-id" (clj->js _job-details))
                                     (swap! !qualification-form assoc :job-details _job-details)
                                     ))
                        :label   "Löschen"}
                       [delete]
                       ]]
                     [mui/grid
                      {:container false
                       :sm        6                         ;medium: 960px
                       :xs        2                         ;extra-small: 0px
                       :style     {:padding "5px" :height "48px"}
                       }]
                     ]
                    )
                  )))
    ))




(defn get-it []
  (let [!profile-state (r/cursor store/app-state [:profile-state])
        !actual-user (r/cursor store/app-state [:actual-user])
        !lose-data-modal (r/cursor !profile-state [:qualification-form :show-lose-data-form-modal])

        !show-job-modal (r/cursor !profile-state [:job-modal :show-job-modal])

        !qualification-form (r/cursor !profile-state [:qualification-form])
        get-value-fn (fn [keys] (if (nil? (get-in @!qualification-form keys)) (get-in @!actual-user keys) (get-in @!qualification-form keys)))
        change-fn (fn [keys] (fn [val] (swap! !qualification-form assoc-in keys val) (log/log "OnChange" keys val @!qualification-form)))



        is-changed-fn? (fn [key] (changes?-val-or-map (get-in @!actual-user key) (get-in @!qualification-form key)))
        do-save? (or
                   (is-changed-fn? [:driving])
                   (is-changed-fn? [:language])
                   (is-changed-fn? [:languages])
                   (is-changed-fn? [:job-status])
                   (is-changed-fn? [:military-service])
                   (is-changed-fn? [:degree])
                   (is-changed-fn? [:expert])
                   (is-changed-fn? [:other-licences])
                   (is-changed-fn? [:other-qualifications])
                   (is-changed-fn? [:red-cross-worker])
                   (is-changed-fn? [:other-emergency-work])
                   (is-changed-fn? [:usable-resources])
                   (is-changed-fn? [:max-duration])
                   (is-changed-fn? [:max-distance])
                   (is-changed-fn? [:data-origin])
                   (is-changed-fn? [:job-details])
                   )
        save-fn (fn []
                  (log/out "save form" @!qualification-form)

                  (swap! !qualification-form assoc :languages (reduce (fn [c [k e]]
                                                                        (cond
                                                                          (= e "") c
                                                                          (= e "del") (assoc c k (js/firebase.firestore.FieldValue.delete))
                                                                          :else (assoc c k e)))
                                                                      {}
                                                                      (dissoc (merge
                                                                                (:languages @!actual-user)
                                                                                (:languages @!qualification-form)) "")))


                  (log/out "save form" @!qualification-form)
                  (save-user @!qualification-form)
                  (swap! !profile-state assoc :qualification-form {})
                  (.scrollTo js/window 0 0)
                  (a/set-page-back)
                  )
        real-back-fn (fn []
                       (.scrollTo js/window 0 0)
                       (swap! !profile-state assoc :qualification-form {})
                       (a/set-page-back))

        back-fn (fn [_]
                  (log/out "back-fn called")
                  (if do-save?
                    (swap! !qualification-form assoc :show-lose-data-form-modal true)
                    (real-back-fn)))
        ]
    (bottom-bar/set-actions back-fn (when do-save? save-fn))
    [mui/grid
     {:container  true
      :direction  "column"
      :justify    "center"
      :alignItems "center"
      :spacing    4
      :style      {:marginTop "25px"}
      }
     [mui/grid
      {:container false
       :md        6                                         ;medium: 960px
       :xs        12                                        ;extra-small: 0px
       }

      [ays-modal/are-you-sure-modal !lose-data-modal "Dieses Formular hat nicht gespeicherte Daten. Willst du es wirklich schließen?" "Eingabe verwerfen"
       real-back-fn]
      [mui/paper {:class ""
                  :style {:textAlign "left" :padding "25px"}}
       [mui/grid
        {:container  true
         :direction  "row"
         :justify    "space-between"
         :alignItems "flex-start"
         :spacing    1
         }
        [mui/grid
         {:container false
          :xs        12                                     ;extra-small: 0px
          :style     {:padding "15px"}
          }
         [:h1
          "Qualifikationen"]
         [:span
          "Wir können im Falle einer Katastrophe natürlich nur die Personen finden, die auch ihre Qualifikationen
          vollständig ausgefüllt haben. Wenn du etwas kannst, was du hier nicht erfasst, dann dann werden wir dich
          im Einsatzfall nicht finden können . Hier gibst du deine Fremdsprachenkenntnisse, Lizenzen,
          Qualifikationen und deinen Beruf an."]
         ]

        [mui/grid
         {:container false
          :xs        12                                     ;extra-small: 0px
          :style     {:padding "15px"}
          }
         [mui/typography {:color (if (empty? (:languages @!actual-user)) "error" "textPrimary") :variant "h6"}
          "Sprachen ⁽*⁾"]
         ]

        (get-languages !actual-user !qualification-form)
        [mui/grid
         {:container false
          :xs        12                                     ;extra-small: 0px
          :style     {:padding "15px"}
          }
         [mui/button
          {:variant   "contained"
           :color     "secondary"
           :startIcon (r/as-element [add])
           :style     {:margin "10px 0 10px 10px" :width "160px"}
           :onClick   (fn []
                        (swap! !qualification-form assoc-in [:languages ""] "basic")
                        (log/log "added lang" @!qualification-form)
                        )
           }
          "Weitere"]
         ]




        [mui/grid
         {:container false
          :xs        12                                     ;extra-small: 0px
          :style     {:padding "15px"}
          }
         [:h2 {:style {:backgroundColor (if (or (nil? (:job-details @!qualification-form)) (= (:job-details @!qualification-form) (:job-details @!actual-user))) "#ffffff" "#ffd6d2")}}
          "Beruf"]
         ]


        [job-selection-modal/modal !show-job-modal
         (fn [jobId]
           (let [jobId (int jobId)
                 job-details (concat (or (:job-details @!qualification-form) (:job-details @!actual-user)) [jobId])]
             (when (not= 0 jobId)
               (log/out "save job modal called " jobId (clj->js job-details))
               (swap! !qualification-form assoc :job-details job-details)
               )))]

        (get-job-details !actual-user !qualification-form)

        [mui/grid
         {:container false
          :xs        12                                     ;extra-small: 0px
          :style     {:padding "15px"}
          }
         [mui/button
          {:variant   "contained"
           :color     "secondary"
           :startIcon (r/as-element [add])
           :style     {:margin "10px 0 10px 10px" :width "160px"}
           :onClick   #(reset! !show-job-modal true)
           }
          "Weitere"]
         ]


        [mui/grid
         {:container false
          :xs        12                                     ;extra-small: 0px
          :style     {:marginTop "15px"}
          }]

        [mui/grid
         {:container false
          :sm        7                                      ;medium: 960px
          :xs        12                                     ;extra-small: 0px
          :style     {:padding "15px"}
          }
         [mui/input-label
          {:style {:backgroundColor (if (is-changed-fn? [:job-status]) "#ffd6d2" "#ffffff")}}
          "Arbeitsverhältnis"
          [mui/select
           {
            :fullWidth true
            :value     (or (get-value-fn [:job-status]) "")
            :onChange  (fn [e] (swap! !qualification-form assoc-in [:job-status] (h/event-value e)))
            :label     "Arbeitsverhältnis"}
           (for [[l-key l-name] (lists/get-jobs)]
             ^{:key (str "job-option" l-key)} [mui/menu-item {:key l-key :value l-key} l-name])
           ]]
         ]
        [mui/grid
         {:container false
          :sm        4                                      ;medium: 960px
          :xs        12                                     ;extra-small: 0px
          :style     {:padding "15px"}
          }

         [mui/input-label
          {:style {:backgroundColor (if (is-changed-fn? [:military-service]) "#ffd6d2" "#ffffff")}}
          "Präsenzdienst oä."
          [mui/select
           {
            :fullWidth true
            :value     (or (get-value-fn [:military-service]) "")
            :onChange  (fn [e] (swap! !qualification-form assoc-in [:military-service] (h/event-value e)))
            :label     "Präsenzdienst oä."}
           (for [[l-key l-name] (lists/get-military)]
             ^{:key (str "job-option" l-key)} [mui/menu-item {:key l-key :value l-key} l-name])
           ]]
         ]



        (case config/CLIENT
          "toe"
          [mui/grid
           {:container false
            :xs        12                                   ;extra-small: 0px
            :style     {:padding "15px"}
            }
           [:h2
            "Führerschein"]
           [mui/form-control-label
            {:control (r/as-element [mui/checkbox
                                     {:checked  (get-value-fn [:driving :licence_a])
                                      :onChange (fn [_ val] ((change-fn [:driving :licence_a]) val))}
                                     ])
             :label   "A"
             :style   {:paddingRight "10px" :backgroundColor (if (is-changed-fn? [:driving :licence_a]) "#ffd6d2" "#ffffff")}
             }
            ]

           [mui/form-control-label
            {:control (r/as-element [mui/checkbox
                                     {:checked  (get-value-fn [:driving :licence_b])
                                      :onChange (fn [_ val] ((change-fn [:driving :licence_b]) val))}
                                     ])
             :label   "B"
             :style   {:paddingRight "10px" :backgroundColor (if (is-changed-fn? [:driving :licence_b]) "#ffd6d2" "#ffffff")}
             }
            ]
           [mui/form-control-label
            {:control (r/as-element [mui/checkbox
                                     {:checked  (get-value-fn [:driving :licence_c])
                                      :onChange (fn [_ val] ((change-fn [:driving :licence_c]) val))}
                                     ])
             :label   "C"
             :style   {:paddingRight "10px" :backgroundColor (if (is-changed-fn? [:driving :licence_c]) "#ffd6d2" "#ffffff")}
             }
            ]
           [mui/form-control-label
            {:control (r/as-element [mui/checkbox
                                     {:checked  (get-value-fn [:driving :licence_d])
                                      :onChange (fn [_ val] ((change-fn [:driving :licence_d]) val))}
                                     ])
             :label   "D"
             :style   {:paddingRight "10px" :backgroundColor (if (is-changed-fn? [:driving :licence_d]) "#ffd6d2" "#ffffff")}
             }
            ]
           [mui/form-control-label
            {:control (r/as-element [mui/checkbox
                                     {:checked  (get-value-fn [:driving :licence_e])
                                      :onChange (fn [_ val] ((change-fn [:driving :licence_e]) val))}
                                     ])
             :label   "E"
             :style   {:paddingRight "10px" :backgroundColor (if (is-changed-fn? [:driving :licence_e]) "#ffd6d2" "#ffffff")}
             }
            ]
           [mui/form-control-label
            {:control (r/as-element [mui/checkbox
                                     {:checked  (get-value-fn [:driving :licence_f])
                                      :onChange (fn [_ val] ((change-fn [:driving :licence_f]) val))}
                                     ])
             :label   "F"
             :style   {:paddingRight "10px" :backgroundColor (if (is-changed-fn? [:driving :licence_f]) "#ffd6d2" "#ffffff")}
             }
            ]
           ]


          [mui/grid
           {:container false
            :xs        12                                   ;extra-small: 0px
            :style     {:padding "15px"}
            }
           [:h2
            "Führerschein"]                                 ;;A;B;BE;
           [mui/form-control-label
            {:control (r/as-element [mui/checkbox
                                     {:checked  (get-value-fn [:driving :licence_a])
                                      :onChange (fn [_ val] ((change-fn [:driving :licence_a]) val))}
                                     ])
             :label   "A"
             :style   {:paddingRight "10px" :backgroundColor (if (is-changed-fn? [:driving :licence_a]) "#ffd6d2" "#ffffff")}
             }
            ]

           [mui/form-control-label
            {:control (r/as-element [mui/checkbox
                                     {:checked  (get-value-fn [:driving :licence_b])
                                      :onChange (fn [_ val] ((change-fn [:driving :licence_b]) val))}
                                     ])
             :label   "B"
             :style   {:paddingRight "10px" :backgroundColor (if (is-changed-fn? [:driving :licence_b]) "#ffd6d2" "#ffffff")}
             }
            ]
           [mui/form-control-label
            {:control (r/as-element [mui/checkbox
                                     {:checked  (get-value-fn [:driving :licence_be])
                                      :onChange (fn [_ val] ((change-fn [:driving :licence_be]) val))}
                                     ])
             :label   "BE"
             :style   {:paddingRight "10px" :backgroundColor (if (is-changed-fn? [:driving :licence_be]) "#ffd6d2" "#ffffff")}
             }
            ]
           [mui/form-control-label
            {:control (r/as-element [mui/checkbox
                                     {:checked  (get-value-fn [:driving :licence_c1])
                                      :onChange (fn [_ val] ((change-fn [:driving :licence_c1]) val))}
                                     ])
             :label   "C1"
             :style   {:paddingRight "10px" :backgroundColor (if (is-changed-fn? [:driving :licence_c1]) "#ffd6d2" "#ffffff")}
             }
            ]
           [mui/form-control-label
            {:control (r/as-element [mui/checkbox
                                     {:checked  (get-value-fn [:driving :licence_c1e])
                                      :onChange (fn [_ val] ((change-fn [:driving :licence_c1e]) val))}
                                     ])
             :label   "C1E"
             :style   {:paddingRight "10px" :backgroundColor (if (is-changed-fn? [:driving :licence_c1e]) "#ffd6d2" "#ffffff")}
             }
            ]
           [mui/form-control-label                          ;C;C1;C1E;CE;
            {:control (r/as-element [mui/checkbox
                                     {:checked  (get-value-fn [:driving :licence_c])
                                      :onChange (fn [_ val] ((change-fn [:driving :licence_c]) val))}
                                     ])
             :label   "C"
             :style   {:paddingRight "10px" :backgroundColor (if (is-changed-fn? [:driving :licence_c]) "#ffd6d2" "#ffffff")}
             }
            ]
           [mui/form-control-label
            {:control (r/as-element [mui/checkbox
                                     {:checked  (get-value-fn [:driving :licence_ce])
                                      :onChange (fn [_ val] ((change-fn [:driving :licence_ce]) val))}
                                     ])
             :label   "CE"
             :style   {:paddingRight "10px" :backgroundColor (if (is-changed-fn? [:driving :licence_ce]) "#ffd6d2" "#ffffff")}
             }
            ]
           [mui/form-control-label
            {:control (r/as-element [mui/checkbox
                                     {:checked  (get-value-fn [:driving :licence_d1])
                                      :onChange (fn [_ val] ((change-fn [:driving :licence_d1]) val))}
                                     ])
             :label   "D1"
             :style   {:paddingRight "10px" :backgroundColor (if (is-changed-fn? [:driving :licence_d1]) "#ffd6d2" "#ffffff")}
             }
            ]
           [mui/form-control-label                          ;D;D1;L;
            {:control (r/as-element [mui/checkbox
                                     {:checked  (get-value-fn [:driving :licence_d])
                                      :onChange (fn [_ val] ((change-fn [:driving :licence_d]) val))}
                                     ])
             :label   "D"
             :style   {:paddingRight "10px" :backgroundColor (if (is-changed-fn? [:driving :licence_d]) "#ffd6d2" "#ffffff")}
             }
            ]
           [mui/form-control-label
            {:control (r/as-element [mui/checkbox
                                     {:checked  (get-value-fn [:driving :licence_l])
                                      :onChange (fn [_ val] ((change-fn [:driving :licence_l]) val))}
                                     ])
             :label   "L"
             :style   {:paddingRight "10px" :backgroundColor (if (is-changed-fn? [:driving :licence_l]) "#ffd6d2" "#ffffff")}
             }
            ]
           ]

          )



        [mui/grid
         {:container false
          :xs        12                                     ;extra-small: 0px
          :style     {:padding "15px"}
          }
         [:h2
          "Lizenz / Ausbildung"]
         ]


        [mui/grid
         {:container false
          :sm        6                                      ;medium: 960px
          :xs        12                                     ;extra-small: 0px
          :style     {:padding "15px"}
          }
         [mui/input-label
          {:style {:backgroundColor (if (is-changed-fn? [:degree]) "#ffd6d2" "#ffffff")}}
          "Studium"
          [mui/select
           {
            :fullWidth true
            :value     (or (get-value-fn [:degree]) "")
            :onChange  (fn [e] (swap! !qualification-form assoc-in [:degree] (h/event-value e)))
            :label     "Studium"}
           (for [[l-key l-name] DEGREES]
             ^{:key (str "degree-option" l-key)} [mui/menu-item {:key l-key :value l-key} l-name])
           ]]

         ]
        [mui/grid
         {:container false
          :sm        6                                      ;medium: 960px
          :xs        12                                     ;extra-small: 0px
          :style     {:padding "15px"}
          }
         [mui/input-label
          {:style {:backgroundColor (if (is-changed-fn? [:expert]) "#ffd6d2" "#ffffff")}}
          "Experte"
          [mui/select
           {
            :fullWidth true
            :value     (or (get-value-fn [:expert]) "")
            :onChange  (fn [e] (swap! !qualification-form assoc-in [:expert] (h/event-value e)))
            :label     "Experte"}
           (for [[l-key l-name] EXPERT]
             ^{:key (str "expert-option" l-key)} [mui/menu-item {:key l-key :value l-key} l-name])
           ]]
         ]
        [mui/grid
         {:container false
          :md        12                                     ;medium: 960px
          :xs        12                                     ;extra-small: 0px
          :style     {:padding "15px"}
          }
         [mui/text-field {:fullWidth    true
                          :label        "Andere Lizenzen"
                          :onChange     (fn [e] (swap! !qualification-form assoc-in [:other-licences] (h/event-value e)))
                          :defaultValue (or (get-value-fn [:other-licences]) "")
                          :style        {:backgroundColor (if (is-changed-fn? [:other-licences]) "#ffd6d2" "#ffffff")}
                          }]
         ]
        [mui/grid
         {:container false
          :md        12                                     ;medium: 960px
          :xs        12                                     ;extra-small: 0px
          :style     {:padding "15px"}
          }
         [mui/text-field {:fullWidth    true
                          :label        "Andere Ausbildungen"
                          :onChange     (fn [e] (swap! !qualification-form assoc-in [:other-qualifications] (h/event-value e)))
                          :defaultValue (or (get-value-fn [:other-qualifications]) "")
                          :style        {:backgroundColor (if (is-changed-fn? [:other-qualifications]) "#ffd6d2" "#ffffff")}
                          }]
         ]



        [mui/grid
         {:container false
          :xs        12                                     ;extra-small: 0px
          :style     {:padding "15px"}
          }
         [:h2
          "Arbeit für Einsatzorganisationen"]
         [:p
          "Wenn du uns deine Erfahrungen für die Arbeit von Einsatzorganisationen (hauptberuflich oder freiwillig)
          mitteilst,können wir deine Einsatzfähigkeit besser einschätzen."
          ]
         ]




        ;[mui/grid
        ; {:container false
        ;  :md 12 ;medium: 960px
        ;  :xs 12  ;extra-small: 0px
        ;  :style {:padding "15px"}
        ;  }
        ; "Folgende Einsatz-Organisation"
        ; [mui/form-label {:style {:margin "10px 0 0 20px"}}
        ;  [mui/select
        ;   {
        ;    :style {:backgroundColor (if (is-changed-fn? [:data-origin]) "#ffd6d2" "#ffffff")}
        ;    :value (or (get-value-fn [:data-origin]) "")
        ;    :onChange (fn [e] (swap! !qualification-form assoc-in [:data-origin] (h/event-value e)))
        ;    :label "Folgende Einsatz-Organisation"}
        ;
        ;   [mui/menu-item {:value "" :key "empty"} ""]
        ;   [mui/menu-item {:value "Rotes Kreuz" :key "Rotes Kreuz"} "Rotes Kreuz"]
        ;   [mui/menu-item {:value "Polizei" :key "Polizei"} "Polizei"]
        ;   [mui/menu-item {:value "Feuerwehr" :key "Feuerwehr"} "Feuerwehr"]
        ;   [mui/menu-item {:value "Bergrettung" :key "Bergrettung"} "Bergrettung"]
        ;
        ;
        ;
        ;   ]]
        ; ]
        [mui/grid
         {:container false
          :md        12                                     ;medium: 960px
          :xs        12                                     ;extra-small: 0px
          :style     {:padding "15px"}
          }


         [mui/form-control-label
          {
           :control (r/as-element [mui/checkbox {:checked  (get-value-fn [:red-cross-worker])
                                                 :onChange (fn [_ val] (swap! !qualification-form assoc-in [:red-cross-worker] val))}])
           :label   "Ich bin/war Rot-Kreuz-Mitarbeiter"
           :style   {:paddingRight "10px" :backgroundColor (if (is-changed-fn? [:red-cross-worker]) "#ffd6d2" "#ffffff")}
           }
          ]
         ]
        [mui/grid
         {:container false
          :md        12                                     ;medium: 960px
          :xs        12                                     ;extra-small: 0px
          :style     {:padding "15px"}
          }
         [:p
          "Wenn du uns mitteilst, dass du bereits beim Roten Kreuz oder anderen Einsatzorganisationen tätig bist, gibt uns das Aufschluss über deine Einsatzverwendbarkeit. Es gilt z.B. hauptberuflich oder freiwillig."]
         [mui/text-field {:readOnly     true
                          :fullWidth    true
                          :label        "Andere Einsatzorganisationen"
                          :onChange     (fn [e] (swap! !qualification-form assoc-in [:other-emergency-work] (h/event-value e)))
                          :defaultValue (or (get-value-fn [:other-emergency-work]) "")
                          :style        {:backgroundColor (if (is-changed-fn? [:other-emergency-work]) "#ffd6d2" "#ffffff")}
                          }]
         ]

        [mui/grid
         {:container false
          :xs        12                                     ;extra-small: 0px
          :style     {:padding "15px"}
          }
         [:h2
          "Diverses"]

         ]
        [mui/grid
         {:container false
          :xs        12                                     ;extra-small: 0px
          :style     {:padding "15px 15px 0px 15px"}
          }
         [:h4
          "Einsetzbare Ressourcen"]
         [:p
          "z.B. Funkgeräte, Fahrzeuge, Transporter, Räumgerät, Generatoren, Pumpen etc."
          ]]
        [mui/grid
         {:container false
          :md        12                                     ;medium: 960px
          :xs        12                                     ;extra-small: 0px
          :style     {:padding "0px 15px 15px 15px"}
          }
         [mui/text-field {:readOnly     true
                          :style        {:backgroundColor (if (is-changed-fn? [:usable-resources]) "#ffd6d2" "#ffffff")}
                          :fullWidth    true
                          :label        "Einsetzbare Ressourcen"
                          :onChange     (fn [e] (swap! !qualification-form assoc-in [:usable-resources] (h/event-value e)))
                          :defaultValue (or (get-value-fn [:usable-resources]) "")
                          }]
         ]
        [mui/grid
         {:container false
          :xs        12                                     ;extra-small: 0px
          :style     {:padding "15px 15px 0px 15px"}
          }
         [:h4
          "Einsatzpräferenz"]
         [:p
          "Wie viele Tage könntest du aus heutiger Sicht für einen Einsatz zur Verfügung stehen?"
          ]
         [:p
          "Wie weit würdest du von deinem Wohnort zu einen Einsatz maximal fahren?"
          ]
         ]
        [mui/grid
         {:container false
          :md        6                                      ;medium: 960px
          :xs        12                                     ;extra-small: 0px
          :style     {:padding "0px 15px 15px 15px"}
          }
         [mui/input-label
          "Maximale Einsatzdauer "
          [mui/select
           {
            :fullWidth true
            :style     {:backgroundColor (if (is-changed-fn? [:max-duration]) "#ffd6d2" "#ffffff")}
            :value     (or (get-value-fn [:max-duration]) "")
            :onChange  (fn [e] (swap! !qualification-form assoc-in [:max-duration] (h/event-value e)))
            :label     "Maximale Einsatzdauer"}
           (for [[l-key l-name] MAX_DURATION]
             ^{:key (str "duration-option" l-key)} [mui/menu-item {:key l-key :value l-key} l-name])
           ]]

         ]
        [mui/grid
         {:container false
          :md        6                                      ;medium: 960px
          :xs        12                                     ;extra-small: 0px
          :style     {:padding "0px 15px 15px 15px"}
          }
         [mui/input-label
          "Maximale Entfernung "
          [mui/select
           {
            :fullWidth true
            :style     {:backgroundColor (if (is-changed-fn? [:max-distance]) "#ffd6d2" "#ffffff")}
            :value     (or (get-value-fn [:max-distance]) "")
            :onChange  (fn [e] (swap! !qualification-form assoc-in [:max-distance] (h/event-value e)))
            :label     "Maximale Entfernung"}
           (for [[l-key l-name] MAX_DISTANCE]
             ^{:key (str "distance-option" l-key)} [mui/menu-item {:key l-key :value l-key} l-name])
           ]]
         ]



        [mui/grid
         {:container false
          :md        5                                      ;medium: 960px
          :xs        12                                     ;extra-small: 0px
          :style     {:padding "15px"}
          }
         [mui/button
          {:variant   "contained"
           :class     "bottom-button"
           :onClick   back-fn
           :startIcon (r/as-element [keyboard-arrow-left])
           }
          "Zurück"]]
        [mui/grid
         {:container false
          :md        5                                      ;medium: 960px
          :xs        12                                     ;extra-small: 0px
          :style     {:padding "15px"}
          }
         [mui/button
          {:variant   "contained"
           :color     "primary"
           :startIcon (r/as-element [save])
           :class     "bottom-button"
           :onClick   save-fn
           }
          "Speichern"]

         ]

        ]]]]
    ))


